import * as React from 'react';

export const IconPen = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    {/* tslint:disable-next-line:max-line-length */}
    <path fill="#2B87DB" fillRule="evenodd" d="M9.945.346l1.699 1.7a1.192 1.192 0 0 1 0 1.7L5.426 9.968l-3.397-3.4L8.247.346c.23-.23.547-.346.85-.346.302 0 .618.115.848.346zm-5.411 10.43L0 12l1.223-4.538 3.31 3.314z"/>
  </svg>
);
